import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Login.css';
import BaseLayout from './BaseLayout';
import { useAuth } from '../context/AuthContext';
import { buildApiUrl } from '../config/api';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(buildApiUrl('/auth/login'), formData);
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('username', user.username);
      login(token, user.username);
      navigate('/home');
    } catch (error) {
      console.error('Login error:', error);
      setError('Invalid credentials');
    }
  };

  return (
    <BaseLayout>
      <div className="login-container">
        <div className="login-form">
          <h2>Welcome Back to LTS</h2>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input 
                type="password" 
                name="password" 
                value={formData.password} 
                onChange={handleChange} 
                required 
                placeholder="Enter your password"
              />
            </div>
            <div className="button-group">
              <button type="submit" className="login-button">Login</button>
              <Link to="/register" className="register-button">Create Account</Link>
            </div>
          </form>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Login;